import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { formatDate, formatFreightValueDisplay } from "../mockData";
import { formatCarrierQueueWaitingTime } from "../availableFreight.mapper";

export default function FreightCard({
  freight,
  isSelected,
  acceptingFreightId,
  onSelect,
  onAcceptFreight,
}) {
  const isAccepting = acceptingFreightId === freight.id;
  const isInQueue = Boolean(freight.isInCarrierQueue);
  const badgeLabel = freight.contractingLabel ?? "PREÇO FIXO";
  const queueWaitingTime = isInQueue ? formatCarrierQueueWaitingTime(freight) : null;

  const handlePrimaryAction = (e) => {
    e.stopPropagation();
    onAcceptFreight(freight);
  };

  return (
    <Box
      className={`lances-freight-card${isSelected ? " lances-freight-card--selected" : ""}${isInQueue ? " lances-freight-card--candidate" : ""}`}
      onClick={() => onSelect(freight.id)}
    >
      {isInQueue ? (
        <Box className="lances-freight-card__candidate-strip">
          Candidato a este frete
        </Box>
      ) : null}

      <Box className="lances-freight-card__header">
        <span className="lances-badge lances-badge--fixed">
          {badgeLabel}
        </span>
        <Box className="lances-freight-card__header-meta">
          <Typography className="lances-freight-card__number">{freight.number}</Typography>
          {freight.shipper && freight.shipper !== "—" ? (
            <Typography className="lances-freight-card__shipper">
              {freight.shipper}
            </Typography>
          ) : null}
        </Box>
      </Box>

      <Box className="lances-freight-card__body">
        <Box className="lances-freight-card__main">
          <Box className="lances-freight-card__route">
            <FmdGoodOutlinedIcon fontSize="small" className="lances-icon-muted" />
            <Typography variant="body2" fontWeight={600}>
              {freight.origin}
            </Typography>
            <ArrowForwardIcon fontSize="small" className="lances-icon-muted" />
            <FmdGoodOutlinedIcon fontSize="small" className="lances-icon-muted" />
            <Typography variant="body2" fontWeight={600}>
              {freight.destination}
            </Typography>
          </Box>

          <Box className="lances-freight-card__specs">
            <Box className="lances-freight-card__spec">
              <LocalShippingOutlinedIcon fontSize="small" />
              <span>{freight.vehicleType}</span>
            </Box>
            <Box className="lances-freight-card__spec">
              <Inventory2OutlinedIcon fontSize="small" />
              <span>{freight.bodyType}</span>
            </Box>
            <Box className="lances-freight-card__spec">
              <CalendarTodayOutlinedIcon fontSize="small" />
              <span>{formatDate(freight.collectionDate)}</span>
            </Box>
          </Box>

          <Box className="lances-freight-card__actions">
            <Button
              variant="contained"
              size="small"
              className={isInQueue ? "lances-btn-leave-queue" : "lances-btn-accept"}
              disabled={isAccepting}
              onClick={handlePrimaryAction}
            >
              {isAccepting ? (
                <CircularProgress
                  size={16}
                  sx={{ color: isInQueue ? "#15803d" : "#fff" }}
                />
              ) : isInQueue ? (
                "Sair da fila"
              ) : (
                "Entrar na fila"
              )}
            </Button>
            <Button
              variant="outlined"
              size="small"
              className="lances-btn-more"
              onClick={(e) => {
                e.stopPropagation();
                onSelect(freight.id);
              }}
            >
              Ver mais
            </Button>
          </Box>
        </Box>

        <Box className="lances-freight-card__pricing">
          <Typography variant="caption" className="lances-freight-card__price-label">
            Valor do Frete
          </Typography>
          <Typography className="lances-freight-card__price-value">
            {formatFreightValueDisplay(freight.freightValue, freight.pricingType)}
          </Typography>
          {isInQueue && (
            <Box className="lances-freight-card__queue-hint-wrap">
              <Typography variant="caption" className="lances-freight-card__queue-hint">
                Você está na fila aguardando contratação
              </Typography>
              {queueWaitingTime ? (
                <Typography variant="caption" className="lances-freight-card__queue-time">
                  há {queueWaitingTime}
                </Typography>
              ) : null}
            </Box>
          )}
        </Box>
      </Box>

      <Typography variant="caption" className="lances-freight-card__published">
        {freight.publishedAgo}
      </Typography>
    </Box>
  );
}
